import React from "react";

import Link from "../Link";
import { Hidden, Container, Typography, Divider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    justifyContent: "center",
    minHeight: 100,
    padding: theme.spacing(1, 4),
    "& > div": {
      padding: theme.spacing(2, 0),
    },
  },
  copyright: {
    flex: 1,
    textAlign: "left",
  },
  linkContainer: {
    maxWidth: 800,
    [theme.breakpoints.up("lg")]: {
      maxWidth: "unset",
    },
    display: "flex",
    flex: 3,
    justifyContent: "space-evenly",
    alignItems: "center",
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="lg" className={classes.root}>
      <Hidden smDown>
        <div className={classes.linkContainer}>
          <Link href={"/terms-of-use"}>
            <Typography variant={"caption"}>Terms and Conditions</Typography>
          </Link>
          <Divider orientation={"vertical"} />
          <Link href={"/privacy"}>
            <Typography variant={"caption"}>Privacy Policy</Typography>
          </Link>
        </div>
      </Hidden>
    </Container>
  );
};

export default Footer;
